<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M10.624 3.918a.5.5 0 0 0-.706-.042l-4.5 4a.5.5 0 0 0 0 .748l4.5 4a.5.5 0 1 0 .664-.748L6.502 8.25l4.08-3.626a.5.5 0 0 0 .042-.706Z"
      clip-rule="evenodd"
    />
  </svg>
</template>
